module.exports = __webpack_public_path__ + "static/img/company_history_renwu2014.85b4690e.jpg";